// extracted by mini-css-extract-plugin
module.exports = {"column":"Columns_column__k0nhF","marker":"Columns_marker__23XK6"};